import { useState } from "react";

/**
 * Product marks share one tile contract across cards, rows, and dialogs.
 * `logoScale` supports marks that already include their own surrounding field.
 */
export default function ProductLogoTile({ product, size, eager = false }) {
  const {
    name,
    logo,
    logoTile,
    logoScale = 0.62,
    color,
    FallbackIcon,
  } = product;
  const [logoFailed, setLogoFailed] = useState(false);
  const glyph = Math.round(size * logoScale);

  return (
    <div
      className="flex flex-shrink-0 items-center justify-center overflow-hidden rounded-md border"
      style={{
        width: size,
        height: size,
        backgroundColor: logoTile?.bg ?? `${color}10`,
        borderColor: logoTile?.border ?? `${color}25`,
      }}
    >
      {(!logo || logoFailed) && FallbackIcon ? (
        <FallbackIcon size={glyph} strokeWidth={1.5} style={{ color }} />
      ) : logoFailed || !logo ? (
        <span
          style={{ color, fontSize: Math.max(9, glyph * 0.5), fontWeight: 700 }}
        >
          {name[0]}
        </span>
      ) : (
        <img
          src={logo}
          alt=""
          className="object-contain"
          style={{ width: glyph, height: glyph }}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          onError={() => setLogoFailed(true)}
        />
      )}
    </div>
  );
}
